export default (state = 'ALL', action = {}) => {
    if (action.type === 'QUESTION_FILTER_CHANGE') {
        return action.payload;
    }
    return state;
};